import errors from 'services/errors'

export default{
  methods: {
    adapterSearch (group, adapter) {
      var options = {
        before (request) {
          this.addPendingRequest(group, request)
        }
      }
      adapter.search(this, this.searchTerm, options).then(response => {
        this[group] = response.body.data.slice(0, this.searchResultslimit)
        this.removePendingRequest(group)
      }, error => {
        this.removePendingRequest(group)
        if (error.status !== 0) {
          errors.notifyResponse(error)
        }
      })
    },
    abortPendingRequests () {
      this.searchPendingRequests.map((r) => r.request.abort())
      this.searchPendingRequests = []
    },
    addPendingRequest (group, request) {
      this.searchPendingRequests.push({group: group, request: request})
    },
    removePendingRequest (group) {
      this.searchPendingRequests = this.searchPendingRequests.filter((e) => e.group !== group)
    },
    ignoreTerm () {
      return this.searchTerm.length < 3
    },
    formatMatch (text) {
      var re = new RegExp(this.searchTerm, 'gi')
      var match = re.exec(text)
      if (match.length === 0) {
        return text
      }
      return text.replace(match[0], '<b><u>' + match[0] + '</u></b>')
    }
  },
  computed: {
    isSearching () {
      return this.searchPendingRequests.length > 0
    }
  },
  watch: {
    'searchTerm': 'search'
  }
}



// WEBPACK FOOTER //
// ./src/mixins/search.js